import React from 'react';

import SvgGoogleLogo from 'src/assets/google-logo';
import { SocialLogin } from './social-login';
import { ProviderProps } from './social-login.types';

export const GoogleLogin = ({
  redirectUrl,
  autoLogin = false,
  isEmbeddedPopup = false,
  isEmbeddedOpenerHandoff = false,
  onSubmit,
  className,
  publicContextSessionId = null,
}: ProviderProps): JSX.Element => (
  <SocialLogin
    redirectUrl={redirectUrl}
    autoLogin={autoLogin}
    isEmbeddedPopup={isEmbeddedPopup}
    isEmbeddedOpenerHandoff={isEmbeddedOpenerHandoff}
    onSubmit={onSubmit}
    className={className}
    icon={<SvgGoogleLogo height={20} width={20} />}
    provider='google'
    buttonText='Continue with Google'
    publicContextSessionId={publicContextSessionId}
  />
);
